import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";
import { SessionLogoutListenerChannelStrategy } from './SessionLogoutListenerChannelStrategy';
import { SessionManagerLogoutListenerStrategy } from '../types';
export var SessionLogoutListener = /*#__PURE__*/function () {
  function SessionLogoutListener(config) {
    _classCallCheck(this, SessionLogoutListener);

    _defineProperty(this, "strategy", void 0);

    switch (config.strategy) {
      case SessionManagerLogoutListenerStrategy.Channel:
        this.strategy = new SessionLogoutListenerChannelStrategy(config);
        break;
    }
  }

  _createClass(SessionLogoutListener, [{
    key: "start",
    value: function () {
      var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this$strategy;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", (_this$strategy = this.strategy) === null || _this$strategy === void 0 ? void 0 : _this$strategy.start());

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function start() {
        return _start.apply(this, arguments);
      }

      return start;
    }()
  }, {
    key: "stop",
    value: function () {
      var _stop = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this$strategy2;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", (_this$strategy2 = this.strategy) === null || _this$strategy2 === void 0 ? void 0 : _this$strategy2.stop());

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function stop() {
        return _stop.apply(this, arguments);
      }

      return stop;
    }()
  }, {
    key: "update",
    value: function () {
      var _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(state, stateExtension, stateNotification) {
        var _this$strategy3;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", (_this$strategy3 = this.strategy) === null || _this$strategy3 === void 0 ? void 0 : _this$strategy3.update(state, stateExtension, stateNotification));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function update(_x, _x2, _x3) {
        return _update.apply(this, arguments);
      }

      return update;
    }()
  }]);

  return SessionLogoutListener;
}();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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